export type MaintenanceConfig = {
  enabled: boolean;
  message: string;
  expectedEnd: string | null;
  supportEmail: string | null;
  engagesAt: string | null;
};

export const MAINTENANCE_MAX_MESSAGE_LENGTH = 500;
export const MAINTENANCE_CONFIRM_WORD = 'ENABLE';
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function formatMaintenanceInstant(isoUtc: string): {
  local: string;
  utc: string;
} {
  const ms = Date.parse(isoUtc);
  if (isNaN(ms)) return { local: isoUtc, utc: isoUtc };
  const d = new Date(ms);
  const local = d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
  return { local, utc: isoUtc };
}

export function localInputToUtcIso(localString: string): string | null {
  if (!localString.trim()) return null;
  const d = new Date(localString);
  if (isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function utcIsoToLocalInput(utcIso: string): string {
  const d = new Date(utcIso);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

export function formatCountdown(totalSeconds: number): string {
  if (totalSeconds <= 0) return '0:00';
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (h > 0) return `${h}:${pad(m)}:${pad(s)}`;
  return `${m}:${pad(s)}`;
}

export function computeEffectiveOn(
  enabled: boolean,
  engagesAt: string | null,
  serverNowMs: number,
): boolean {
  if (enabled) return true;
  if (engagesAt == null) return false;
  const ms = Date.parse(engagesAt);
  if (isNaN(ms)) return false;
  return serverNowMs >= ms;
}

export function mockArmTwoMinutes(fromMs: number): string {
  return new Date(fromMs + 2 * 60_000).toISOString();
}
